export default function getUsageTrackingURL(
  userId: string,
  trackingType: string
): string {
  if (!userId) {
    // eslint-disable-next-line no-console
    console.warn('You need to provide a userId as first argument');
  }
  if (!trackingType) {
    // eslint-disable-next-line no-console
    console.warn('You need to provide a trackingType as second argument');
  }

  if (!userId || !trackingType) {
    throw new Error('Arguments passed to getUsageTrackingUrl are invalid.');
  }

  return `/kv/user_${userId}_usage_statistics_${trackingType}`;
}
